// removed by extract-text-webpack-plugin
module.exports = {"contentCarousel":"_1Ori_O-3VngvkK3u7IXyDD","img":"QJdItEUseeX859t9qo_OK","content":"_1gD7AwP8lUPta4NqVL6X9A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/post-featured-carousel/PostFeaturedCarousel.css
// module id = 557
// module chunks = 0